import React from 'react'

const ComingSoonHeaderIconWhite = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="white-glow-soon">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <path 
        d="M16 4L20 12L18 12L18 22C18 23.1046 17.1046 24 16 24C14.8954 24 14 23.1046 14 22L14 12L12 12L16 4Z" 
        stroke="#ffffff" 
        strokeWidth="2"
        fill="#ffffff"
        fillOpacity="0.2"
        filter="url(#white-glow-soon)"
      />
      
      <circle cx="16" cy="14" r="2" stroke="#ffffff" strokeWidth="1.5" fill="none"/>
      <circle cx="16" cy="14" r="1" fill="#ffffff" opacity="0.6"/>
      
      <path 
        d="M14 24C13 25 12 26 12 28C12 29 13 30 14 30" 
        stroke="#ffffff" 
        strokeWidth="1.5" 
        strokeLinecap="round"
        opacity="0.8"
      />
      <path 
        d="M16 24C16 26 15.5 27 15.5 28.5C15.5 29.5 16 30 16.5 30" 
        stroke="#ffffff" 
        strokeWidth="1.5" 
        strokeLinecap="round"
        opacity="0.9"
      />
      <path 
        d="M18 24C19 25 20 26 20 28C20 29 19 30 18 30" 
        stroke="#ffffff" 
        strokeWidth="1.5" 
        strokeLinecap="round"
        opacity="0.8"
      />
      
      <path d="M6 8L6.5 9.5L8 10L6.5 10.5L6 12L5.5 10.5L4 10L5.5 9.5L6 8Z" fill="#ffffff" opacity="0.7"/>
      <path d="M26 8L26.5 9.5L28 10L26.5 10.5L26 12L25.5 10.5L24 10L25.5 9.5L26 8Z" fill="#ffffff" opacity="0.7"/>
      <path d="M8 18L8.3 19L9 19.3L8.3 19.6L8 20L7.7 19.6L7 19.3L7.7 19L8 18Z" fill="#ffffff" opacity="0.5"/>
      <path d="M24 18L24.3 19L25 19.3L24.3 19.6L24 20L23.7 19.6L23 19.3L23.7 19L24 18Z" fill="#ffffff" opacity="0.5"/>
      
      <line x1="10" y1="10" x2="8" y2="8" stroke="#ffffff" strokeWidth="1" strokeLinecap="round" opacity="0.4"/>
      <line x1="22" y1="10" x2="24" y2="8" stroke="#ffffff" strokeWidth="1" strokeLinecap="round" opacity="0.4"/>
      <line x1="10" y1="16" x2="7" y2="16" stroke="#ffffff" strokeWidth="1" strokeLinecap="round" opacity="0.4"/>
      <line x1="22" y1="16" x2="25" y2="16" stroke="#ffffff" strokeWidth="1" strokeLinecap="round" opacity="0.4"/>
    </svg>
  )
}

export default ComingSoonHeaderIconWhite
